import PropTypes from 'prop-types';
import * as React from 'react';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { createComponent } from '../core/create-component.js';
import { Icon } from '../icon/icon.component.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const propTypes = {
  skin: PropTypes.oneOf(['standard', 'cta', 'cta-left', 'unstyled']),
  width: PropTypes.oneOf(['standard', 'full-width']),
  covering: PropTypes.bool,
  withIcon: PropTypes.bool,
  withIconSeparated: PropTypes.bool,
  to: PropTypes.string
};
const propKeysToRemove = ['skin', 'withIcon', 'withIconSeparated', 'covering'];
const Link = createComponent({
  displayName: 'Link',
  root: 'a',
  propTypes,
  propKeysToRemove,
  propConfig: {
    derivedProps() {
      return useSwanContext();
    },
    classNames(props) {
      const {
        skin = 'standard',
        width = 'standard',
        withIcon,
        withIconSeparated,
        covering
      } = props;
      const classNameSet = new Set(['swan-link']);
      if (skin !== 'standard') classNameSet.add("swan-link-skin-".concat(skin));
      if (width === 'full-width') classNameSet.add("swan-link-full-width");
      if (withIcon || withIconSeparated) classNameSet.add('swan-link-with-icon');
      if (withIconSeparated) classNameSet.add('swan-link-with-icon-separated');
      if (covering) classNameSet.add('swan-link-covering');
      return classNameSet;
    },
    processProps(props, derivedProps) {
      // TODO: Write stories and tests for globalLinkComponent
      if (derivedProps.globalLinkComponent) {
        return _objectSpreadProps(_objectSpread({}, props), {
          as: props.as || props.component || derivedProps.globalLinkComponent
        });
      }
      if (!props.href && !props.as && !props.component && !props.render) {
        return _objectSpread({
          href: props.to || undefined
        }, props);
      }
      return props;
    },
    wrapChildren(_ref, dp, node) {
      let {
        skin
      } = _ref;
      if (skin === 'cta') {
        return /*#__PURE__*/React.createElement(React.Fragment, null, node, /*#__PURE__*/React.createElement(Icon, {
          iconType: "arrowRight",
          ml: "1"
        }));
      }
      if (skin === 'cta-left') {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
          iconType: "arrowLeft",
          mr: "1"
        }), node);
      }
      return node;
    }
  }
});
export { Link };